import { Box, IconButton, Menu, MenuItem } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ObjectChip from "./ObjectChip";
import { useState } from "react";

const MultipleObjectChip = ({ objs, objIds, modelName }) => {
  if (!objs && !objIds) {
    throw new Error(
      "Objects or objectIds must be provided to MultipleObjectChip",
    );
  }
  if (objs && objIds) {
    throw new Error(
      "Only one of objects or objectIds should be provided to MultipleObjectChip",
    );
  }

  const [andchorEl, setAnchorEl] = useState(null);
  const open = Boolean(andchorEl);

  const handleClick = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const nbItems = objs ? objs.length : objIds.length;

  if (nbItems === 0) return <></>;

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100%"
    >
      {nbItems} items
      <IconButton onClick={handleClick} sx={{ p: 0.5 }}>
        <KeyboardArrowDownIcon sx={{ scale: "0.8" }} />
      </IconButton>
      <Menu anchorEl={andchorEl} open={open} onClose={handleClose}>
        {objs &&
          objs.map((v, index) => (
            <MenuItem key={index} onClick={handleClose}>
              <ObjectChip modelName={modelName} obj={v} />
            </MenuItem>
          ))}
        {objIds &&
          objIds.map((v, index) => (
            <MenuItem key={index} onClick={handleClose}>
              <ObjectChip modelName={modelName} objId={v} forceLoad />
            </MenuItem>
          ))}
      </Menu>
    </Box>
  );
};

export default MultipleObjectChip;
